export const SET_TYPE_LIST = (state, list) => {
    state.typeList = list;
};

export const SET_SILOS = (state, silos) => {
    state.silos = silos;
};

export const SET_PRODUCTS = (state, products) => {
    state.products = products;
};

export const SET_INDIVIDUAL_EXPORT = (state, individualExport) => {
    state.individualExport = {
        idPortoOrigem: individualExport.origin_port ?? state.individualExport.idPortoOrigem,
        portoDestino: individualExport.destination_port ?? state.individualExport.portoDestino,
        contraparte: individualExport.counterparty ?? state.individualExport.contraparte,
        codigoProduto: individualExport.product ?? state.individualExport.codigoProduto,
        idSafra: individualExport.harvest ?? state.individualExport.idSafra,
        volumeTon: individualExport.cargo_volume ?? state.individualExport.volumeTon,
        descricao: individualExport.description ?? state.individualExport.descricao,
        numeroBl: individualExport.bl_number ?? state.individualExport.numeroBl,
        dataBl: individualExport.bl_date ?? state.individualExport.dataBl,
        numeroAprovacao: individualExport.approval_number ?? state.individualExport.numeroAprovacao
    };
};

// List/Filter mutations
export const SET_FILTER = (state, filter) => {
    state.filter = {
        page: filter.page ?? state.filter.page,
        size: filter.size ?? state.filter.size,
        contract_number: filter.contract_number ?? state.filter.contract_number,
        status: filter.status ?? state.filter.status ?? [],
        initialDate: filter.initialDate ?? state.filter.initialDate,
        endDate: filter.endDate ?? state.filter.endDate,
        origin: filter.origin ?? state.filter.origin,
        destination: filter.destination ?? state.filter.destination,
        type: filter.type ?? state.filter.type
    };
};

export const SET_OPERATION_LIST = (state, operations) => {
    state.operationList = operations;
};

export const CLEAR_FILTER = state => {
    state.filter = {
        page: 0,
        size: 10,
        contract_number: '',
        status: [],
        initialDate: null,
        endDate: null,
        origin: 0,
        destination: 0,
        type: 4
    };
};
